import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { colorArray, setCurrencyFormat } from '../../../utils/helpers';

function TopLocation({ height, data, type }) {

    const reduceCallback = (acc, day) => {
        const toFind = type?.value === 0 ? day?.state : day?.city
        if (acc?.[toFind]) {
            acc[toFind] = Number(acc[toFind]) + Number(day?.amount)
        } else {
            acc[toFind] = Number(day?.amount)
        }
        return acc
    }

    const dataByLocation = data?.reduce(reduceCallback, {}) || {};
    let dataToPlot = Object.entries(dataByLocation).map((entry) => {
        const [city, SalesAmount] = entry
        return {
            city,
            SalesAmount
        }
    })
    dataToPlot = dataToPlot?.sort((a, b) => b.SalesAmount - a.SalesAmount).slice(0, 15)
    return (
        <ResponsiveContainer height={height}>
            <BarChart
                data={dataToPlot}
                margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
                layout="vertical"
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis type="category" dataKey="city" />
                <Tooltip formatter={value => setCurrencyFormat(Number(value).toFixed(2), true)} />
                <Legend />
                <Bar barCategoryGap={10}
                    dataKey="SalesAmount"
                    fill="#00a0fc"
                >
                    {
                        data?.map((entry, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Cell key={`cell-${index}`} fill={colorArray[index % 5]} />
                        ))
                    }
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

TopLocation.propTypes = {
    height: PropTypes.number.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    type: PropTypes.objectOf({ value: '', label: '' }).isRequired
};


export default TopLocation;